const accounts = [
    {
        "uuid": "1",
        "category": "hospital",
        "username": "mingwang",
        "name": "王小明",
        "email": "mingwang@gmail.com",
        "activatedOn": "2020-10-20T01:38:49.881Z",
        "createdOn": "2020-10-20T01:38:49.881Z",
        "creator": "連仁芢"
    },
    {
        "uuid": "2",
        "category": "hospital",
        "username": "coco",
        "name": "林小可",
        "email": "coco@gmail.com",
        "activatedOn": "2020-11-25T01:38:49.881Z",
        "createdOn": "2020-11-25T01:38:49.881Z",
        "creator": "連仁芢"
    },
    {
        "uuid": "3",
        "category": "pmf",
        "username": "xinshin",
        "name": "陳小鑫",
        "email": "xinshin@gmail.com",
        "activatedOn": "2010-01-08T01:38:49.881Z",
        "expiredOn": "2020-01-08T01:38:49.881Z",
        "createdOn": "2010-01-08T01:38:49.881Z",
        "creator": "連仁芢"
    },
    {
        "uuid": "4",
        "category": "pmf",
        "username": "thousand",
        "name": "張小千",
        "email": "thousand@gmail.com",
        "activatedOn": "2018-02-12T01:38:49.881Z",
        "createdOn": "2018-02-12T01:38:49.881Z",
        "creator": "連仁芢"
    }
];

export default accounts;